export default __webpack_public_path__ + "static/media/practice-exam.be872496.svg";